import styles from './NotFound.module.css';
import erro404 from '../../assets/erro_404.png'
import ButtonPrincipal from '../../components/ButtonPrincipal';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
    const navegar = useNavigate();

    return (
        <>
            <div className={styles.conteudoContainer}>
                <span className={styles.text404}>404</span>

                <h1 className={styles.title}>
                    Ops! Página não encontrada.
                </h1>

                <p className={styles.paragraph}>
                    Tem certeza de que era isso que você estava procurando?
                </p>

                <p className={styles.paragraph}>
                    Aguarde uns instantes e recarregue a página, ou volte para a página inicial.
                </p>

                <div
                    className={styles.buttonContainer}
                    onClick={() => navegar(-1)}
                >
                    <ButtonPrincipal tamanho="lg">
                        Voltar
                    </ButtonPrincipal>
                </div>

                <img
                    className={styles.imagemCachorro}
                    src={erro404}
                    alt="Cachorro de óculos e vestido como humano"
                />
            </div>
            <div className={styles.whiteSpace}></div>
        </>

    )
}